import React, { useEffect, FC } from 'react';
import { addLinkQueryParams } from '../../../../server/utils/addLinkQueryParams';
import { homeViewed } from '../../../../utils/bi';
import { HomeData } from '../../../../shared/types';
import ArticlesList from './ArticleList';

interface HomeProps {
  data: HomeData;
}

const Home: FC<HomeProps> = ({
  data: {
    home: { heading, description },
    articles,
  },
}) => {
  useEffect(() => {
    homeViewed();
  }, []);

  return (
    <div className="main-page">
      <h1>{heading}</h1>
      <div className="rich-text" dangerouslySetInnerHTML={{ __html: addLinkQueryParams(description) }} />
      <ArticlesList articles={articles} />
    </div>
  );
};

export default Home;
